<script>
    import http from '../api/http.js';
	import { currentPage, selectedGroup } from '../store.js';
    import { Button, ButtonGroup, Card, CardBody, CardFooter, CardHeader, Pagination, PaginationItem, PaginationLink, Table, } from 'sveltestrap';
    import WizardProgress from "../components/WizardProgress.svelte";
    import OptionButton from "../components/OptionButton.svelte";
    import Row from "../components/Row.svelte";
    import Expander from "../components/Expander.svelte";
    import { vesselDeploymentLightImage, attributeDeploymentImage, attributeDeploymentLightImage, generalImage, cogImage, autoDeployImage, includeSubGroupsImage, useCredentialsImage, computerCommandImage, computerCommandLightImage, notifyUserImage, autoCommandImage,backupRestoreImage} from '../common/Images.js'
    import { createEventDispatcher } from 'svelte';
    import Search from '../components/Search.svelte';

    const dispatch = createEventDispatcher();

    let command = {
        computers : [],
        packageVersionId : 0,
        includeSubGroups : true,
        UseCredentials : false,
        CredentialsId : 0,
        commandToAll : false,
        autoCommand : false,
        delayable : false,
        maxDelayMinutes : 0,
        notify : false,
        notificationMinutes : 0,
        unlimitedDelay : false,
        createBackupRestorePoint: false,
        backupRestoreName: ""
    };

    let selectedAttribute;
    let pageNumber = 1;
    let totalPageCount = 0;
    let totalComputerCount = 0;

    const displayNumbers = [10, 25, 50, 100, 200]

    let displayNumber = displayNumbers[0];

    const setPageNumber = (number) => {
        pageNumber = number;    
    }

    let errorMessage = '';

    let packageErrorMesssage = '';
    let versionErrorMessage = '';
    let commandInstallationType = ''; 

    let isSearching = false;
    let searchTerm = '';
    let previousSearchTerm = '';
    
    let affectedComputers = [];
    let computers = [];    
    let packages = [];
    let versions = [];
    let attributes = [];
    let credentials = [];
    let selectedAttributes = [];
    let exceptionComputers = [];
    let useCredential = false;
    
    let commandTypeHeading = 'Send Command Manually';
    let commandTypeDescription = '';

    const computerMode = 'computer';
    const attributeMode = 'attribute';

    const showComputers = 'computers';
    const showSelectedComputers = 'selectedComputers';
    
    const showAttributes = 'attributes';
    const showAffectedComputers = 'affectedComputers';

    let computerTableView = showComputers;
    let attributeTableView = showAttributes;

    let selectedComputers = [];
    let allComputerSelected = false;
    
    let commandType = computerMode;

    export let visible;
    let selectedPackage = {
        id: 0
    };

    let selectedVersion = {
        id: 0,
        name: "",
        versionType: ""
    };

    let selectedCredential = {
        id: 0,
        name: ""
    };

    let step2ImageSource = '';

    $: {
		tabItems[1].imageSource = step2ImageSource;
	}

    $: {
        useCredential;
        resetSelections();
        if(commandType == attributeMode){
            getAffectedComputers();
        }else if(commandType == computerMode){
            loadComputers();
        }
    }

    let showAllSteps = false;
    let activeTabValue = 0;
    let activeTabDescription = 'General Settings'
    let tabItems = [
        {
            value: 0,
            description: "General",
            isComplete: false,
            imageSource: generalImage
        },
        {
            value: 1,
            description: 'Command Type',
            isComplete: false,
        },
        {
            value: 2,
            description: "Additional Settings",
            isComplete: false,
            imageSource: cogImage
        }
    ];

    $: {
        activeTabDescription = tabItems[activeTabValue].description;
    }

    $: {
        if (commandType === computerMode) {
        commandTypeHeading = 'Send Command Manually';
        commandTypeDescription = 'Manually select the computers you wish to send the command to to from the table below.';
        }
        else {
            commandTypeHeading = 'Send Command Via Attribute';
            commandTypeDescription = 'Sending a command via attributes will affect all computers with the attributes you have selected attached to them.';
        }
    }

    $: {
        if ($selectedGroup != undefined) {
            loadPackages();
            getComputerAttributes();
            getCredentials();
        }
    }

    $: {
        if (commandType === computerMode) {
            step2ImageSource = computerCommandLightImage;
        }
        else if (commandType === attributeMode) {
            step2ImageSource = attributeDeploymentLightImage;
        }
    }

     $: {
        selectedAttributes;
        getAffectedComputers()
    }

     $: {    
        displayNumber;
        pageNumber;
        command.includeSubGroups;
        selectedVersion;
        loadComputers();
    }
    
    $:{
        selectedPackage;
        getVersions(selectedPackage.id);
    }

    $: {
        if (command.maxDelayMinutes > 0 || command.unlimitedDelay){
            command.delayable = true;
        }
        else {
            command.delayable = false;
        }
    }

    $:{
        if(selectedVersion != undefined){
            if(selectedVersion.versionType.toLocaleLowerCase() == 'install'){
                commandInstallationType = 'Install';
            }
            else{
                commandInstallationType = 'Transfer';
                command.createBackupRestorePoint = false;
                command.backupRestoreName = "";
            }
        }
    }

    const handleTabClick = (event) => {
		activeTabValue = event.detail.value;
		activeTabDescription = event.detail.description;
	}

    const loadPackages = async () => {
        const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/software/all/forselect/${$selectedGroup}`);
        packages = await res.json();
        if (packages.length > 0) {
            selectedPackage = packages[0];
            await getVersions(selectedPackage.id);
            packageErrorMesssage = "";            
        }
        else{
            packageErrorMesssage = "No packages to show. First ensure you have created a package before creating a command.";
            versions = [];
            selectedVersion = {
                id: 0,
                name: "",
                versionType: ""
            };
        }
    }

   const getVersions = async (id) => {
    if (selectedPackage != undefined) {
        const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/software/version/forselect/${id}/${$selectedGroup}/false`);
        versions = await res.json();
            if (versions.length > 0) {
                selectedVersion = versions[0];
                versionErrorMessage = "";
            }
            else{
                versionErrorMessage = "No versions to show. First ensure you have created a package version before creating a command.";
            }
        }
    }

    const getCredentials = async () => {
        if (command.CredentialsId != undefined) {
            const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/credentials/${$selectedGroup}`);
            credentials = await res.json();
            selectedCredential = credentials[0];
        }
    }

    const loadComputers = async () => {
        if ({$selectedGroup} != undefined && selectedVersion != undefined && selectedVersion.id != 0) {
            let url = "";
            if(searchTerm.length > 0){
                url = `/deploy/dashboard/computers/byrepoaccess/${$selectedGroup}/${displayNumber}/${pageNumber}/0/true/${command.includeSubGroups}/${selectedVersion.id}/${searchTerm != '' ? `${searchTerm}` : ''}/${useCredential}`
            }
            else{
                url = `/deploy/dashboard/computers/byrepoaccess/${$selectedGroup}/${displayNumber}/${pageNumber}/0/true/${command.includeSubGroups}/${selectedVersion.id}/${useCredential}`
            }
            const res = await http.get(window.apiBaseUrl + url);
            if (res.status === 200) {
                let uiComputerCollection = await res.json();
                computers = uiComputerCollection.computers;
                totalPageCount = uiComputerCollection.totalPageCount;
                totalComputerCount = uiComputerCollection.noPaginationComputerCount;        
                checkStoredComputers();
            }
            else if (res.status === 404) {
                computers = [];
                totalPageCount = 0;
                totalComputerCount = 0;
            }
        }
        else {
            computers = [];
            totalPageCount = 0;
            totalComputerCount = 0;
        }
        computers = computers;  
    }

    const searchComputers = async () => { 
        isSearching = true;    
        let interval = setInterval( async () => {
        if (searchTerm != previousSearchTerm) {
            pageNumber = 1;
            loadComputers();   
        }   
        if (!isSearching) {
            clearInterval(interval);
        }
        previousSearchTerm = searchTerm;      
        }, 1000);    
    }


    const selectComputer = (computer) =>{
        if (computer.selected) {
            selectedComputers.push(computer);
        }
        else {
            selectedComputers = selectedComputers.filter(v => v.id != computer.id);
        }
        selectedComputers = selectedComputers;
        computers = computers;
    }

     const toggleSelectAllComputers = () =>{
        if (allComputerSelected) {
            computers.forEach(computer => {
                computer.selected = true;
                if(!selectedComputers.map(c => c.id).includes(computer.id)){
                    selectedComputers.push(computer);
                }});
            }
            else {
                computers.forEach(computer => {
                computer.selected = false;
                selectedComputers = [];
            });
        }
        computers = computers;
        selectedComputers = selectedComputers;
    }

   const checkStoredComputers = () => {
        computers.forEach(computer => {
        if (selectedComputers.map(c => c.id).includes(computer.id)) {
            computer.selected = true;
        }
        });
    }

   const getAffectedComputers = async () => {
        var attributesCsv = "";
        selectedAttributes.forEach(attribute => {
            attributesCsv += attribute.id.toString() + ",";
        });  
        attributesCsv = attributesCsv.slice(0, -1);
        if (attributesCsv != "") {
            const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/computers/${$selectedGroup}/${attributesCsv}/${command.includeSubGroups}/${selectedPackage.id}/computersbyattribute/false/${useCredential}`);
            if (res.status === 200) {
                let uiAffectedComputers = await res.json();
                affectedComputers = uiAffectedComputers.affectedComputers;
                exceptionComputers = uiAffectedComputers.exceptionComputers;
            }
            else { 
                affectedComputers = [];
                exceptionComputers = [];
            }
        }   
        else {
            affectedComputers = [];
            exceptionComputers = [];
        }     
    }

    const getComputerAttributes = async () => {
        const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/attribute/computer/true/${$selectedGroup}`);
        attributes = await res.json(); 
        selectedAttribute = attributes[0];
    }

    const addComputerAttribute = (attribute) => {
        if (!selectedAttributes.includes(attribute)) {
            selectedAttributes.push(attribute);
            selectedAttributes = selectedAttributes;
            errorMessage = "";
        }
        else {
            errorMessage = "Cannot add duplicate attributes";
        }
    }

    const validateCommand = () => {
        let validated = true;
        errorMessage = "";
        if (commandType === computerMode) {
            if (selectedComputers.length == 0) {
                errorMessage = "Please select at least one computer";
                validated= false;
            }
        }
        else if (commandType === attributeMode) {
            if (selectedAttributes.length == 0) {
                errorMessage = "Please select at least one attribute";
                validated= false;
            }
        }
        else if (selectedVersion.id === 0) {
            errorMessage = "Please select a package version";
            validated= false;
        }
        if((command.createBackupRestorePoint) && (command.backupRestoreName.length === 0 || command.backupRestoreName.length > 100)){
            errorMessage = "Restore Point Name must be at least 1 character long and less than 100 characters.";
            validated= false;
        }
        return validated;
    }
    
    const createCommand = async () => {
        command.packageVersionId = selectedVersion.id;
        if (commandType === computerMode) {
            if (selectedComputers.length > 0) {
                command.computers = selectedComputers;
            }
        }
        else if (commandType === attributeMode) {
            command.computers = affectedComputers;
        }

        command.UseCredentials = useCredential;

        if (command.UseCredentials){
            command.CredentialsId = selectedCredential.id;
        }

        if(validateCommand()){
            const res = await http.post(window.apiBaseUrl + `/deploy/dashboard/command/${$selectedGroup}`, command);
            if (res.status === 200) {
                visible = false;
                dispatch('commandCreated');
            }
            else {
                errorMessage = "Error creating command";
            }
        }
        
    }

    const removeComputerAttribute = (attribute) => {
        if (selectedAttributes.includes(attribute)) {
            selectedAttributes = selectedAttributes.filter((a) => a.id != attribute.id);
            selectedAttributes = selectedAttributes;
        }
    }

    const setCommandType = (type) => {
        commandType = type;
        resetSelections();
    }

    const resetSelections = () => {
        if (commandType === computerMode) {
            computers.forEach(computer => {
                computer.selected = '';
            });
            allComputerSelected = '';
            selectedComputers = [];
        }
        else if (commandType === attributeMode) {
            selectedAttributes = [];
        }
    }

    const setComputerTableView = (view) => {
        computerTableView = view;
    }

    const setAttributeTableView = (view) => {
        attributeTableView = view;
    }

    const onPrevious = () => {
		activeTabValue--;
	}

	const onNext = () => {
		activeTabValue++;
	}

    const cancelCreateCommand = () => {
		visible = false;
	}
</script>

<div class="d-flex">
	<div class="breadcrumb">
		<span id="breadcrumb-cancel" class="mr-3 cancel" on:mousedown={() => cancelCreateCommand()}>Go Back</span>
		<div class="vl mr-3"></div>
		<span>Commands</span> 
		<i class="fa fa-angle-right"></i>
			<span class="active current">Create Command</span>
		<i class="fa fa-angle-right"></i>
		<span class="active">{activeTabDescription}</span>
	</div>
</div>

<div class="container">
    <div class="row">
        <h4 class="m-0 font-weight-bold">Create Command <span class="text-danger font-weight-normal"> {errorMessage}</span></h4>
    </div>

    <div class="row">
         <div class="col-10 col-md-10 col-sm-12">
            {#if activeTabValue === 0}
            <div class="fade-in-out">
                <Row>
                    <div class="form-group">
                        <label for="software-name">Package Name</label>
                        <select id="package-select" class="form-control" bind:value={selectedPackage}>
                            {#each packages as softwarePackage}
                                <option id="package-{softwarePackage.id}" value={softwarePackage}>{softwarePackage.name}</option>
                            {/each}
                        </select>
                        <div class="text-danger">{packageErrorMesssage}</div>
                    </div>
                    <div class="detail">
                        <h4 class="font-weight-bold">
                            Software Package 
                        </h4>
                        <p>Select the software package that you wish to create the command for.</p>
                    </div>
                </Row>

                <Row>
                    <div class="form-group">
                        <label for="software-name">Package Version</label>
                        <select id="package-version-select" class="form-control" bind:value={selectedVersion}>
                            {#each versions as version}
                                <option id="package-version-{version.id}" value={version}>{version.name}</option>
                            {/each}
                        </select>
                        <div class="text-danger">{versionErrorMessage}</div>
                    </div>
                    <div class="detail">
                        <h4 class="font-weight-bold">
                            Package Version
                        </h4>
                        <p>Select the version of the package you wish to create a command for.</p>
                    </div>
                </Row>
            </div>
            {/if}

            {#if activeTabValue === 1}
            <div class="fade-in-out">
                <Row>
                    <div>
                        <label for="jobMode" class="col-form-label mb-2">Command Type</label>
                        <div class="d-flex" id="jobMode">
                            <OptionButton active={commandType === computerMode} on:click={() => setCommandType(computerMode)} imageUrl={computerCommandImage} activeImageUrl={computerCommandLightImage} imageHeight="90" imageWidth="90" id="computer-command-type"></OptionButton>
                            <OptionButton active={commandType === attributeMode} on:click={() => setCommandType(attributeMode)} imageUrl={attributeDeploymentImage} activeImageUrl={attributeDeploymentLightImage} imageHeight="90" imageWidth="90"  id="attribute-deployment-type"></OptionButton>
                        </div>
				    </div>

                    <div class="detail">
                        <h4 class="font-weight-bold">
                            {commandTypeHeading}
                        </h4>
                        <p>{commandTypeDescription}</p>
                    </div>
                </Row>

                <Row>
                    <div class="form-group d-flex flex-column">
                        <label for="include-subgroups">Include Subgroups</label>
                        <img src="{includeSubGroupsImage}" alt="includeSubGroups">
                    </div>

                    <div class="detail">
                        	<div class="custom-control custom-switch ml-4">
								<input type="checkbox" class="custom-control-input" id="include-subgroups" bind:checked={command.includeSubGroups} >
								<label class="custom-control-label font-weight-bold text-primary" for="include-subgroups">Include Subgroups</label>
							</div>	
                        <p>Include subgroups when adding computers manually or via attributes.</p>	
                    </div>
                </Row>
                <Row>
                    <div class="form-group d-flex flex-column">
                        <label for="include-Credentials">Credentials</label>
                        <img src="{useCredentialsImage}" alt="Credentials">
                    </div>
                    <div class="detail">
                        <div class="custom-control custom-switch ml-4">
                            <input type="checkbox" class="custom-control-input" id="include-credentials" bind:checked={useCredential}>
                            <label class="custom-control-label font-weight-bold text-primary" for="include-credentials">Use Credentials</label>
                        </div>

                        {#if (useCredential)}
                            <select id="credential-select" class="form-control" bind:value={selectedCredential}>
                                {#each credentials as credential}
                                    <option id="credential-{credential.id}" value={credential}>{credential.name}</option>
                                {/each}
                            </select>
                        {/if}

                    </div>
                </Row>
                {#if commandType === computerMode}
                <Card>
                    <CardHeader>
                        <div class="d-flex row">
                            <h4 class="mt-1 ml-1 font-weight-bold text-primary"><i class="fas fa-desktop"></i> Computers</h4>
                            <div class="col-sm-3">
                                <Search id="deployments-search-input" bind:searchTerm placeholder="Search Computers..." on:input={() => searchComputers()} on:focusout={() => isSearching =  false}></Search>   
                            </div>
                            <ButtonGroup class="ml-auto">
                                <Button color="primary" id="computer-button" class="btnGrp" on:click={() => setComputerTableView(showComputers)} active={computerTableView === showComputers}>Computers</Button>
                                <Button color="primary" id="selected-computer-button" class="btnGrp" on:click={() => setComputerTableView(showSelectedComputers)} active={computerTableView === showSelectedComputers }>Selected Computers ({selectedComputers.length})</Button> 
                            </ButtonGroup>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                {#if computerTableView === showComputers}
                                    <thead>
                                        <tr>
                                            <th><input id="select-all-computers" type="checkbox" bind:checked={allComputerSelected} on:change={() => toggleSelectAllComputers()}/>{selectedComputers.length > 0 ? `(${selectedComputers.length})` : ''}</th>       
                                            <th>Computer Name</th>
                                            <th>Vessel Name</th>
                                            <th>IP Address</th>
                                            <th>Deploy Version</th>
                                        </tr>          
                                    </thead>    
                                    <tbody>
                                    {#each computers as computer}            
                                        <tr id="vessel-row-{computer.host}">
                                            <td><input id="vessel-checkbox-{computer.id}" type="checkbox" bind:checked={computer.selected} on:change={() => selectComputer(computer)}/></td>
                                            <td class="computerRow">{computer.hostName}</td>
                                            <td>{computer.vesselName}</td>
                                            <td>{computer.ipAddress}</td>
                                            <td>{computer.deployVersion}</td>
                                        </tr>            
                                    {/each}
                                    </tbody>
                                {:else if computerTableView === showSelectedComputers}
                                    <thead>
                                        <tr>
                                            <th>Computer Name</th>
                                            <th>Vessel Name</th>
                                        </tr>          
                                    </thead>    
                                    <tbody>
                                    {#each selectedComputers as computer}            
                                        {#if ((computer.hostName.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()))) || (computer.vesselName.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()))}   
                                            <tr id="computer-row-{computer.name}">
                                                <td>{computer.hostName}</td>
                                                <td>{computer.vesselName}</td>
                                            </tr>
                                        {/if}            
                                    {/each}
                                    </tbody>
                                {/if}
                            </table>
                        </div> 
                    </CardBody>
                    <CardFooter>
                    {#if computerTableView == showComputers}
                        <div class="pagination bg-light shadow-none ml-0 d-flex">
                            <small class="mt-3 mr-auto">{pageNumber === 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > totalComputerCount ? totalComputerCount:pageNumber * displayNumber)} of {totalComputerCount} computers</small>
                            <div class="mt-2 justify-content-center">
    
                            <Pagination>
                                <PaginationItem disabled={pageNumber === 1}>
                                <PaginationLink id="pagination-first-page-button" first on:click={() => pageNumber = 1} href="#"/>
                                </PaginationItem>
                                <PaginationItem  disabled={pageNumber === 1}>
                                <PaginationLink id="pagination-previous-page-button" previous on:click={() => setPageNumber(pageNumber - 1)} href="#" />
                                </PaginationItem>
                                {#if totalPageCount > 5}
                                {#each Array(5) as _, count}
                                    {#if pageNumber > 3 && pageNumber < totalPageCount - 2}
                                    <PaginationItem active={pageNumber === count + pageNumber} >
                                        <PaginationLink id="pagination-page-{pageNumber + count}-button" on:click={() => setPageNumber(pageNumber + count)} href="#">{pageNumber + count}</PaginationLink>
                                    </PaginationItem>
                                    {:else if pageNumber <= 3}
                                    <PaginationItem active={pageNumber === count + 1} >
                                        <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                                    </PaginationItem>
                                    {:else if pageNumber >= totalPageCount - 2}
                                    <PaginationItem active={pageNumber === totalPageCount - 4 + count} >
                                        <PaginationLink id="pagination-page-{totalPageCount - 4 + count}-button" on:click={() => setPageNumber(totalPageCount - 4 + count)} href="#">{totalPageCount - 4 + count}</PaginationLink>
                                    </PaginationItem>
                                    {/if}
                                {/each}
                                {:else}
                                {#each Array(totalPageCount) as _, count}
                                    <PaginationItem active={pageNumber === count + 1} on:click={() => pageNumber == count + 1}>
                                    <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                                    </PaginationItem>
                                {/each}
                                {/if}      
    
                                <PaginationItem disabled={pageNumber === totalPageCount}>
                                <PaginationLink id="pagination-next-page-button" next href="#" on:click={() => setPageNumber(pageNumber + 1)} />
                                </PaginationItem>
                                <PaginationItem disabled={pageNumber === totalPageCount}>
                                <PaginationLink id="pagination-last-page-button" last href="#" on:click={() => setPageNumber(totalPageCount)}/>
                                </PaginationItem>
                            </Pagination>
                            
                            </div>
                            <div class="mt-2 ml-auto">
                            <select class="form-select" id="displayNumberSelect" bind:value={displayNumber}>
                            {#each displayNumbers as displayNumber}
                            <option value="{displayNumber}">{displayNumber}</option>
                            {/each}
                            </select>
                            <label class="ml-1" id="displayNumberLabel" for="displayNumberSelect">Per page</label>     
                            </div>  
                        </div>
                    {/if}
                    </CardFooter>
                </Card>
                     
                {:else}
                 <Row>
                    <div class="row">
                        <div class="col-6">
                            <select id="attribute-select" class="form-control" bind:value={selectedAttribute}>
                                {#each attributes as attribute}
                                    <option id="attribute-select-option-{attribute.id}" value={attribute}>{attribute.name} | {attribute.value} ({attribute.group})</option>
                                {/each}
                            </select>
                        </div>
                        <div class="col-6">
                            <button id="add-vessel-attribute-button" class="btn btn-outline-primary" on:click={() => addComputerAttribute(selectedAttribute)} disabled={selectedAttribute == undefined}>Add Attribute</button>
                        </div>
                    </div>
                    <div class="detail">
                        <h4 class="font-weight-bold">
                            Computer Attributes
                        </h4>
                        <p>Select the computer attribute(s) you wish the command to apply to.</p>
                    </div>
                 </Row>

                <Card>
                    <CardHeader>
                        <div class="d-flex row">
                            <h4 class="mt-1 ml-1 font-weight-bold text-primary">{attributeTableView == showAttributes ? "Attributes" : "Affected Computers" }</h4>
                             <ButtonGroup class="ml-auto">
                                <Button color="primary" id="computer-button" class="btnGrp" on:click={() => setAttributeTableView(showAttributes)} active={attributeTableView == showAttributes}>Attributes</Button>
                                <Button color="primary" id="attribute-button" class="btnGrp" on:click={() => setAttributeTableView(showAffectedComputers)} active={attributeTableView == showAffectedComputers }>Affected Computers ({affectedComputers.length})</Button> 
                            </ButtonGroup>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                            {#if attributeTableView === showAttributes}
                                <thead>
                                    <tr>
                                        <th>Attribute Name</th>
                                        <th>Attribute Value</th>
                                        <th>Actions</th>
                                    </tr>          
                                </thead>    
                                <tbody>
                                {#each selectedAttributes as attribute}            
                                    <tr id="attribute-row-{attribute.name}">
                                        <td>{attribute.name}</td>
                                        <td>{attribute.value}</td>
                                        <td>
                                            <button class="btn btn-primary btn-sm" on:click={() => removeComputerAttribute(attribute)}><i class="fa fa-trash"></i></button>
                                        </td>
                                    </tr>            
                                {/each}
                                </tbody>
                                {:else if attributeTableView === showAffectedComputers}
                                  <thead>
                                    <tr>
                                        <th>Computer Name</th>
                                        <th>Vessel Name</th>
                                    </tr>          
                                </thead>    
                                <tbody>
                                {#each affectedComputers as computer}            
                                    <tr id="computer-row-{computer.name}">
                                        <td>{computer.hostName}</td>
                                        <td>{computer.vesselName}</td>
                                    </tr>            
                                {/each}
                                </tbody>
                            {/if}
                            </table>
                        </div> 
                    </CardBody>
                    <CardFooter>

                    </CardFooter>
                    </Card>

                    <Row>
                        <Expander expanderTitle="Show ({exceptionComputers.length}) Excluded Computers">
                            <div class="affected-grid">
                                {#each exceptionComputers as computer}
                                    <div class="mt-2">
                                        <p>{computer.name} (<span class="text-info">{computer.vesselName}</span>)</p>
                                        <p class="text-danger">{computer.exceptionReason}</p>
                                    </div>   
                                {/each}
                            </div>
                        </Expander>
                        <div class="detail">
                            <h4 class="font-weight-bold">
                                Excluded Computers
                            </h4>
                            <p>Computers that should be affected by this command but won't be as well as the reason are displayed here.</p>
                        </div>
                    </Row>
                {/if}
                </div>
            {/if}

            {#if activeTabValue === 2}
             <div class="fade-in-out">
                <Row>
                    <div class="form-group d-flex flex-column">
                        <label for="auto-deploy">Notify Users</label>
                        <img src="{notifyUserImage}" alt="">
                    </div>
                    
                    <div class="detail">
                        <div class="custom-control custom-switch ml-4">
                            <input type="checkbox" class="custom-control-input" id="notify" bind:checked={command.notify} >
                            <label class="custom-control-label font-weight-bold text-primary" for="notify">Notify Users</label>
                        </div>	
                        <p>Notify users when the command has been sent.</p>	
                    </div>
                </Row>

                <Row>
                    <div class="form-group">
                        <div class="d-flex" id="notification-time">
                            <label for="software-name d-flex mt-2">
                                Command Notification Time (Minutes)
                            </label>
                        </div>
                        <input type="number" class="form-control" id="command-notification-time" min=0  bind:value={command.notificationMinutes} disabled={!command.notify}>
                    </div>
                    
                    <div class="detail">
                        <h4 class="font-weight-bold">
                            Command Notifications
                        </h4>
                        <p>Sets the amount of time you want to notify the users onboard before the command is processed</p>
                    </div>
                </Row>


                <Row>
                    <div class="form-group">
                        <div class="d-flex" id="delay-time">
                            <label for="software-name d-flex mt-2">
                                Command Delay Time (Minutes)
                            </label>
                            <div class="custom-control custom-switch ml-auto">
                                <input type="checkbox" class="custom-control-input" id="unlimited-delay" bind:checked={command.unlimitedDelay} >
                                <label class="custom-control-label font-weight-bold text-primary" for="unlimited-delay">Unlimited Delays</label>
                            </div>
                        </div>
                        <input type="number" class="form-control" id="command-delay-time" min=0  bind:value={command.maxDelayMinutes} disabled={command.unlimitedDelay}>
                    </div>
                    
                    <div class="detail">
                        <h4 class="font-weight-bold">
                            Command Delays
                        </h4>
                        <p>Allows users onboard to delay the command preventing it processing for a set period of time.</p>
                    </div>
                </Row>

                {#if commandInstallationType == "Install"}
                    <Row>
                        <div class="form-group d-flex flex-column">
                            <label for="">Create Backup Restore Point</label>
                            <img src="{backupRestoreImage}" alt="">
                        </div>
                        <div class="detail">
                            <div class="custom-control custom-switch ml-4">
                                <input type="checkbox" class="custom-control-input" id="backup-restore" bind:checked={command.createBackupRestorePoint} >
                                <label class="custom-control-label font-weight-bold text-primary" for="backup-restore">Create Backup Restore Point</label>
                            </div>	
                            <p>A backup restore point will be created prior to running the command. Please note that this feature is not supported by Windows Server Editions.</p>	
                        </div>
                    </Row>
                    <Row>
                        <div class="form-group">
                            <div class="d-flex" id="backup-restore-name">
                                <label for="backup-restore-name">
                                    Restore Point Name
                                </label>
                            </div>
                            <input type="text" class="form-control" id="backup-restore-name" placeholder="e.g. My First Restore Point" bind:value={command.backupRestoreName} disabled={!command.createBackupRestorePoint}>
                        </div>
                        
                        <div class="detail">
                            <h4 class="font-weight-bold">
                                Restore Point Name
                            </h4>
                            <p>Sets the name of your restore point in windows.</p>
                        </div>
                    </Row>
                {/if}
                <Row>
                    <div class="form-group d-flex flex-column">
                        <label for="include-subgroups">Auto {commandInstallationType}</label>
                        <img src="{autoCommandImage}" alt="">
                    </div>
                    <div class="detail">
                        <div class="custom-control custom-switch ml-4">
                            <input type="checkbox" class="custom-control-input" id="auto-command" bind:checked={command.autoCommand} >
                            <label class="custom-control-label font-weight-bold text-primary" for="auto-command">Auto {commandInstallationType}</label>
                        </div>	
                        <p>Command will be automatically sent to the computer.</p>	
                    </div>
                </Row>

            </div>
            {/if}
            <div class="d-flex">
				<div class="ml-auto mb-4 mt-2">
					<button class="btn btn-outline-secondary" id="cancel-button" on:click={() => cancelCreateCommand()}>Cancel</button>
					{#if activeTabValue > 0}
					<button class="btn btn-outline-primary ml-2" on:click={onPrevious}>Previous</button>
					{/if}
					{#if activeTabValue ==  2}
						<button  class="btn btn-outline-primary ml-2" on:click={() => createCommand()}>
							<span class="text">Create Command</span>
						</button>
						{:else if activeTabValue != 2}
						<button id="next-button" class="btn btn-outline-primary" on:click={onNext} disabled={activeTabValue ==  2}>Next</button>
					{/if}
				</div>
			</div>
         </div>

        <div class="col-2 d-flex">
            <div class="ml-auto fade-in-out delay">
                <WizardProgress bind:activeTabValue={activeTabValue} bind:showAllSteps={showAllSteps} bind:items={tabItems} on:tabClick={handleTabClick}/>
            </div>
        </div>
    </div>
</div>

<style>
    .detail{
		display: flex;
		flex-direction: column;
		justify-content: center;
		max-width: 440px;
	}

	.detail h4{
		font-size: 1em;
		font-weight: 600;
	}

	.detail p{
		font-size: 0.8em;
	}
	
	@media(max-width:1600px){
		.detail h4{
			font-size: 0.9em;
		}

		.detail p{
			font-size: 0.7em;
		}

		.col-10{
			flex: 0 0 68.33333%!important;
		}
	}

	.vl{
		border-left: 1px solid #B9B9B9;
		height: 100%;
	}

    h4{
        color: #233763 ;
		font-size: 1.1em;
    }

	h5{
		color: #233763 ;
		font-size: 1.05em;
	}

	.detail p{
		font-size: 0.9em;
		color: #6C757D;
	}

    @media(min-width: 1200px){
        .container{
            min-width: 1400px!important;
        }

    }

	.text-danger{
		opacity: 0.7;
	}

	#cancel-button{
		color: #233763;
		border-color: #233763;
	}

	#cancel-button:hover{
		color: #fff;
		background-color: #233763;
	}

	button:disabled, button[disabled]{
		z-index: 0;
	}

    .disabled{
        opacity: 0.6;
    }

    .form-group img{
        width: 100px;
        height: 100px;
    }

    #delay-time{
        padding: 0px;
    }

    #delay-time label{
        margin-bottom: 0px;
    }

</style>